"use client";

// Available colors for preview banners (must match workspace-ports.json availableColors)
// Note: yellow, orange excluded - too similar to amber which is reserved for release branches
// Tailwind safelist - these classes must be included in build:
// bg-lime-400 bg-emerald-400 bg-cyan-400 bg-sky-400 bg-violet-400 bg-fuchsia-400 bg-pink-400 bg-rose-400 bg-amber-400 bg-teal-400 bg-indigo-400 bg-purple-400 bg-red-400 bg-green-400 bg-blue-400 bg-slate-400 bg-zinc-400 bg-stone-400
// text-lime-900 text-emerald-900 text-cyan-900 text-sky-900 text-violet-900 text-fuchsia-900 text-pink-900 text-rose-900 text-amber-900 text-teal-900 text-indigo-900 text-purple-900 text-red-900 text-green-900 text-blue-900 text-slate-900 text-zinc-900 text-stone-900
// Ordered for maximum contrast between consecutive colors (warm/cool alternating)
// amber is at the end so it won't be auto-assigned via hash, but can be explicitly set for release branches
const availableColors = [
  "violet",
  "emerald",
  "rose",
  "cyan",
  "indigo",
  "lime",
  "fuchsia",
  "teal",
  "red",
  "sky",
  "purple",
  "green",
  "pink",
  "blue",
  "slate",
  "zinc",
  "stone",
  "amber",
];

// Fallback hash for when color isn't assigned
function hashString(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }
  return Math.abs(hash);
}

export function PreviewBanner() {
  const previewBranch = process.env.NEXT_PUBLIC_PREVIEW_BRANCH;
  const previewPr = process.env.NEXT_PUBLIC_PREVIEW_PR;
  const localBranch = process.env.NEXT_PUBLIC_LOCAL_BRANCH;
  const previewColor = process.env.NEXT_PUBLIC_PREVIEW_COLOR;

  const branch = previewBranch || localBranch;
  const isLocal = !previewBranch && !!localBranch;

  if (!branch) return null;

  // Use assigned color if valid, otherwise fall back to hash-based selection
  const color =
    previewColor && availableColors.includes(previewColor)
      ? previewColor
      : availableColors[hashString(branch) % availableColors.length];

  return (
    <div
      className={`fixed bottom-2 right-2 z-50 bg-${color}-400 text-${color}-900 text-sm font-medium py-1.5 px-3 rounded-md shadow-md`}
      title={!isLocal && previewPr ? `PR #${previewPr}` : undefined}
    >
      {isLocal ? `Local: ${branch}` : `Preview: ${branch}`}
    </div>
  );
}
